export default __webpack_public_path__ + "static/media/PROCESSMETHOD_SHEETMETAL_WATERJET_CUTTING.87d08a4e.png";